import React, {useContext, useState} from "react";
import {useMutation} from "@apollo/client";
import {Button, Col, Container, Row} from "react-bootstrap";
import {SaveContactFormMutation} from "./ContactFormQueries";
import {saveData} from "../../../helpers/Api";
import FlashMessage from "../../shared/FlashMessage";
import {AuthContext} from "../../../context/authContext";
import PageSubTitle from "../../../layout/PageSubTitle";

const ContactForm = () => {
  const [flash, setFlash] = useState({});
  const { user } = useContext(AuthContext)
  const data = user
    ? { fName: user.fName, lName: user.lName, email: user.email, phone: user.phone, message: '' }
    : { fName: '', lName: '', email: '', phone: '', message: '' }
  const [saveCall] = useMutation(SaveContactFormMutation)

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: saveCall,
      query_key: 'createContactForm',
      flash_callback: setFlash,
      success: (res) => {
        setFlash({ type: 'success', message: 'Mesajul a fost trimis cu success. Va multumim.' })
        event.target.reset()
      }
    })
  }

  return (
    <Container
      className="contact-form position-absolute top-50 start-50 translate-middle bg-lighter-branding p-4 w-75 rounded shadow">
      <div className='d-sm-flex align-items-center'>
        <Col className='flex-grow-1 p-3'>
          <PageSubTitle className="h3 mb-3 fw-normal" title="Contact" />
          <form onSubmit={onSubmit}>
            <Row className="mb-2">
              <Col md={6}>
                <label htmlFor="fName">Prenume</label>
                <input type='text' name='fName' className="form-control" id="fName" defaultValue={data.fName}
                       required={true} />
              </Col>
              <Col md={6}>
                <label htmlFor="lName">Nume</label>
                <input type="text" name='lName' className="form-control" id="lName" defaultValue={data.lName}
                       required={true} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={6}>
                <label htmlFor="email">Email</label>
                <input type="email" name="email" className="form-control" id="email" defaultValue={data.email}
                       required={true} />
              </Col>
              <Col md={6}>
                <label htmlFor="phone">Telefon</label>
                <input type="text" name='phone' className="form-control" id="phone" defaultValue={data.phone} />
              </Col>
            </Row>
            <Row className="mb-2">
              <Col md={12}>
                <label htmlFor="email">Mesaj</label>
                <textarea name="message" className="form-control" id="message" rows={3} required={true}
                          placeholder={'Lasati un mesaj'} />
              </Col>
            </Row>
            <Row className="mb-3">
              <FlashMessage flash={flash} buttons={
                <Button type='submit' className='float-end'>Trimite</Button>
              } />
            </Row>
          </form>
        </Col>
        <Col sm={3} md={4} className="contact-icon d-md-block d-none">
          <i className="bi bi-envelope-at" />
        </Col>
      </div>
    </Container>
  )
};

export default ContactForm;
